import React from 'react';
import classNames from 'classnames';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import Icon from '../../common/components/Icon';

const DragHandle = SortableHandle(() => <Icon icon="arrows" />);

const Locking = ({ locking, active, onClick, duplicationActive }) => {
	const classes = classNames('locking--old', {
		'locking--active': active,
		'locking--duplication-active': duplicationActive
	});

	return (
		<div className={classes} onClick={() => onClick(locking)}>
			<div className="locking__drag-drop">
				<DragHandle />
			</div>
			{locking.name}
		</div>
	);
};

export default SortableElement(Locking);



// WEBPACK FOOTER //
// ./src/js/plan/lockings/Locking.js